import Listing from "../components/listings/listing.component"

const ListingPage = () => {
  return (
    <Listing />
  )
}

export default ListingPage